import React, { useContext, useState } from 'react'
import { AddProductButton, Card, Container, Separator } from './style'
import ProductSection, { ItemOrderType } from './OrderSections/Product';
import DetailsSection from './OrderSections/Details';
import MainInfosSection from './OrderSections/MainInfos';
import axios from 'axios';
import { FeedbackContext } from '../../../../contexts/FeedbackContext';

export interface OrderType {
  id?: number
  supplier: string
  seller: string
  client: string
  orderType: string
  orderDate: string
  deliveryDate: string
  paymentTerm: string
  shippingType: string
  shippingValue: string
  trackingCode: string
  attachments: string[]
  extraInfo: string
  items: ItemOrderType[]
  totalQuantity?: number
  taxes?: number
  total?: number
}

export interface ManageOrderStateByProduct {
  order: OrderType
  setOrder: React.Dispatch<React.SetStateAction<OrderType>>
  index: number
}

const productInitialState:ItemOrderType = {
  requestedProduct: {
    product: '',
    format: '', 
    diameter: '',
    thickness: '',
    length: '',
    finishing: '',
    weigth: '',
    quantity: '',
    specs: ''
  },
  offeredProduct: {
    product: '',
    format: '', 
    diameter: '',
    thickness: '',
    length: '',
    finishing: '',
    weigth: '',
    quantity: '',
    specs: ''
  }
}

const CreateOrder = () => {
  const { setFeedback } = useContext(FeedbackContext)
  const [ order, setOrder ] = useState<OrderType>({
    supplier: '',
    seller: 'João Leite',
    client: '',
    orderType: '',
    orderDate: '',
    deliveryDate: '',
    paymentTerm: '',
    shippingType: '',
    shippingValue: '',
    trackingCode: '',
    attachments: [],
    extraInfo: '',
    items: [productInitialState]
  })

  const handleCreateOrder = () => {
    axios.post(`${process.env.REACT_APP_STEEL_ORDERS_BASE_URL}/order`, order)
      .then(response => {
        if(response.data) {
          setFeedback({
            isOpen: true,
            message: 'Pedido criado com sucesso',
            statusOk: true
          })
        }
      })
      .catch(error => {
        console.error(error)
        setFeedback({
          isOpen: true,
          message: 'Erro ao criar pedido',
          statusOk: false
        })
      })
  }

  return(
    <Container>
      <AddProductButton onClick={handleCreateOrder}>Criar pedido</AddProductButton>
      <Card>
        <MainInfosSection order={order} setOrder={setOrder} />
        <Separator />
        <DetailsSection order={order} setOrder={setOrder} />
      </Card>
      {order.items.map((item, index) => (
        <Card key={index}>
          <ProductSection order={order} setOrder={setOrder} index={index} />
        </Card>
      ))}
      <AddProductButton onClick={() => setOrder(prev => ({
        ...prev,
        items: [...prev.items, productInitialState]
      }))}>+ Adicionar produto</AddProductButton>
    </Container>
  )
}

export default CreateOrder